export default __webpack_public_path__ + "static/media/user.20799d4f.jpg";